<template>
  <IMenu v-model="isShow" width="278" :placement="placement" @hide="onHideMenu">
    <template #menu>
      お気に入りショップに追加しませんか？<br />
      新作情報をメールでお届けします。
    </template>
  </IMenu>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { getFromStorage, setToStorage } from '@/js/lib/helper/expirable-local-storage';
import { useMemberStore } from '@/js/lib/store/member';
import IMenu from '@/js/components/molecules/IMenu.vue';

const props = withDefaults(
  defineProps<{
    memberId: number;
    placement?: string;
  }>(),
  {
    placement: 'bottom',
  },
);
const KEY = 'close-follow-balloon';
const TTL = 24 * 86400;
const isShow = ref(false);
const memberStore = useMemberStore();
const onHideMenu = () => {
  setToStorage({ key: KEY, value: true, expirationSeconds: TTL });
};

onMounted(() => {
  isShow.value = !memberStore.followedMemberIds.includes(props.memberId) && !getFromStorage({ key: KEY });
});
</script>
